export const viewByOptions = [
  { label: 'Canvasser', value: 'canvassers' },
  { label: 'Method', value: 'method' },
  { label: 'Partner', value: 'partner' },
  { label: 'Teams', value: 'teams' },
];

export const intervalOptions = [
  { label: 'Show Totals', value: 'totals' },
  { label: 'Show by Week', value: 'week' },
  { label: 'Show by Month', value: 'month' }
];

export const tableFields = [
  { key: 'name', _style: { width: '22%', minWidth: 111 } },
  { key: 'total_petitions', _style: { width: '13%', minWidth: 132 } },
  { key: 'total_prospects', label: 'Prospects', _style: { width: '13%', minWidth: 132 } },
  { key: 'checked_out', _style: { width: '13%', minWidth: 123 } },
  { key: 'scanned', label: 'Scanned', _style: { width: '13%', minWidth: 111 } },
  { key: 'checked_in', label: 'Checked In', _style: { width: '13%', minWidth: 111 } },
  { key: 'sigs', label: 'Signatures', _style: { width: '13%', minWidth: 111 } },
  { key: 'valid', label: 'Valid %', _style: { width: '13%', minWidth: 88 } },
];

export const tdWithExpandIcon = {
  key: 'show_details',
  label: '',
  _style: { width: '1%', minWidth: 60 },
};
